import { addBreadcrumb } from '@sentry/browser';
import { SentryPayoutAccountStep } from 'src/modules/sentry-taxonomy';

export type SentryPayoutAccountSurface =
	| 'events_list'
	| 'event_management'
	| 'financial_dashboard'
	| 'personal_data'
	| 'public_event'
	| 'synthetic'
	| 'unknown';

type SentryPayoutAccountState = {
	isOpen: boolean;
	step: SentryPayoutAccountStep;
	surface: SentryPayoutAccountSurface;
};

const initialState: SentryPayoutAccountState = {
	isOpen: false,
	step: 'recipient_details',
	surface: 'unknown',
};

let payoutAccountState = initialState;

export const getSentryPayoutAccountSurface = (
	pathname: string
): SentryPayoutAccountSurface => {
	if (pathname === '/me/events') return 'events_list';
	if (pathname === '/financeiro') return 'financial_dashboard';
	if (pathname === '/me/account') return 'personal_data';
	if (/^\/(admin|promoter)\/event\//.test(pathname)) {
		return 'event_management';
	}
	if (/^\/(event|evento)\//.test(pathname)) return 'public_event';
	return 'unknown';
};

export const getSentryPayoutAccountState = () => payoutAccountState;

export const addSentryPayoutAccountBreadcrumb = (
	action: string,
	data?: Record<string, unknown>
) => {
	addBreadcrumb({
		category: 'payout_account',
		level: 'info',
		message: `payout_account.${action}`,
		data: {
			step: payoutAccountState.step,
			surface: payoutAccountState.surface,
			...data,
		},
	});
};

export const setSentryPayoutAccountState = (
	nextState: SentryPayoutAccountState
) => {
	const previousState = payoutAccountState;
	payoutAccountState = nextState;

	if (
		previousState.isOpen === nextState.isOpen &&
		previousState.step === nextState.step &&
		previousState.surface === nextState.surface
	) {
		return;
	}
	if (!previousState.isOpen && !nextState.isOpen) return;

	const message = !previousState.isOpen && nextState.isOpen
		? 'payout_account.opened'
		: previousState.isOpen && !nextState.isOpen
			? 'payout_account.closed'
			: 'payout_account.step_changed';

	addSentryPayoutAccountBreadcrumb(
		message.replace('payout_account.', ''),
		previousState.isOpen && !nextState.isOpen
			? {
					step: previousState.step,
					surface: previousState.surface,
				}
			: undefined
	);
};

export const resetSentryPayoutAccountState = () => {
	setSentryPayoutAccountState(initialState);
};
